import { IMG_HOST } from "@/config/api";

export const IMAGE_SIZE_LARGE = "large";
export const IMAGE_SIZE_MIDDLE = "middle";
export const IMAGE_SIZE_SMALL = "small";
export const PRODUCT_DRECTION_FRONT = 2;
export const PRODUCT_DRECTION_RIGHT_45 = 1;
export const PRODUCT_DRECTION_SIDE = 3;
export const CDN = IMG_HOST();
export const PER_PAGE = 40;
export const CURRENCY_COOKIE_NAME = "currency";
export const CURRENCY_VERSION = "CURRENCY_VERSION";
export const LANGUAGE_NAME = "firmoo_lan"; //当前语言
export const PC_COOKIE_NAME = "pc";
export const PREVIEW_LANG = "preview_lang";
export const JWT_COOKIE_NAME = "jwt";
export const RX_COOKIE_NAME = "rx";
export const RX_STR_COOKIE_NAME = "rxStr";
export const BUBBLE_COOKIE_NAME = "bubble";
export const ANNOUNCEMENT_COOKIE_NAME = "announcement";
export const VISITOR_COOKIE_NAME = "U1RJe61cDi4a";
export const INVITECODE_COOKIE_NAME = "invite_code";
export const UNIONCHILDCODE_COOKIE_NAME = "union_child_code";
export const MARKETING_PAGES_LIST_COOKIE_NAME = "markrting_product_list"; //二次营销页面列表
export const ATTACHMENT_COOKIE_NAME = "attachment";
export const IS_NEED_GET_VISITOR = "record_vId"; //cookie 里面的是否需要请求浏览者详情 user/visitor 标志位
export const IS_OLD_CUSTOMER_COOKIE_NAME = "is_old_customer";

export const LOCAL_STORAGE_NAMES = {
    ORDER_PRODUCTS: "order_products",
    TOURIST_ID: "tourist_id",
    COUPON_CODE: "coupon_code",
    IS_CLICK_TRACK_GUIDE: "IS_CLICK_TRACK_GUIDE", //查看物流指引记录
    ADDRESS_DEFAULT_LOCAL: "ADDRESS_DEFAULT_LOCAL", //地址缓存
    ADDRESS_BILLING_LOCAL: "ADDRESS_BILLING_LOCAL", //账单地址缓存
    PRODUCT_SLIDER_GUIDE: "PRODUCT_SLIDER_GUIDE", //商品详情页引导
    TRY_ON_WISH_LIST: "TRY_ON_WISH_LIST", //tryOn wish list
    IS_SHOW_TRY_ON_GUI_ALL: "IS_SHOW_TRY_ON_GUI_ALL",
    IS_SHOW_TRY_ON_SCREEN: "IS_SHOW_TRY_ON_SCREEN",
    IS_SHOW_TRY_ON_SHARE: "IS_SHOW_TRY_ON_SHARE",
    IS_SHOW_TRY_ON_LISTL: "IS_SHOW_TRY_ON_LISTL",
    LENS_GUIDE_TIP: "LENS_GUIDE_TIP",
    USER_RESENT_SEARCH: "USER_RESENT_SEARCH", //用户搜索记录，最多存10个
};

export const PRODUCT_TYPE = {
    GLASSES: "glasses",
    ADD_ON: "addons",
    VIRTUALS: "virtuals",
};

// export const OCEAN_PAY = {
//   account: "",
//   terminal: "",
//   development_url: "https://secure.oceanpayment.com/gateway/service/test",
//   production_url: "https://secure.oceanpayment.com/gateway/service/pay",
//   secure_code: "",
// };

export const PAYMENTS = {
    PAYPAL: "paypal",
    CREDIT_CARD: "oceanpayment",
    BILLING: "billing",
    PACYPAL: "pacypay",
    ONERWAY: "onerway",
    PACYPAL_SOFORT: "pacypay pacypal_sofort",
    PACYPAL_GIROGATE: "pacypay pacypal_girogate",
    USEEPAY: "useepay",
    KLARNA: "klarna",
    OXXO: "OXXO",
    MERCADOPAGO: "MercadoPago",
    SPEI: "SPEI",
    APPLEPAY: "applepay",
    GOOGLEPAY: "googlepay",
    WEBPAY: "Webpay",
    SERVIPAG: "Servipag",
    PIX: "PIX",
    BOLETO: "Boleto",
    BLIK: "BLIK",
    PAYU: "PayU",
    IDEAL: "iDEAL",
    PRZELEWY24: "Przelewy24",
    ADYEN: "adyen",
    OXXO_D: "OXXO-d",
    MERCADOPAGO_D: "MercadoPago-d",
    SPEI_D: "SPEI-d",
    PIX_D: "PIX-d",
    BOLETO_D: "Boleto-d",
    WEBPAY_D: "Webpay-d",
    SERVIPAG_D: "Servipag-d",
    AIRWALLEX: "Airwallex",
    KUESKI_D: "Kueski-d",
    DLOCAL: "dlocal",
};

export const PAYMENT_METHODS = {
    PAYPAL: {
        image: "https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-200px.png",
        tips: "PAYPAL_EXPLAIN",
        title: "PAYPAL_TITLE",
        id: PAYMENTS.PAYPAL,
        maxWidth: "28%",
    },
    CREDIT_CARD: {
        image: "https://df5apg8r0m634.cloudfront.net/images/b9ede88f2290b19c3b0cbc72f13fb255.png",
        tips: "CREDIT_CARD_EXPLAIN",
        title: "CREDIT_CARD_TITLE",
        id: PAYMENTS.CREDIT_CARD,
        maxWidth: "25%",
    },
    BILLING: {
        image: "https://df5apg8r0m634.cloudfront.net/images/48e3eae9c24ee1a8d908a0d858a09a2e.png",
        tips: "PAYPAL_BILLING",
        title: "BILLING_TITLE",
        id: PAYMENTS.BILLING,
        maxWidth: "28%",
    },
    PACYPAL: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2021/0909/230a09b6812c899887c12bf78ca7d080.jpg",
        tips: "CREDIT_CARD_EXPLAIN",
        title: "CREDIT_CARD_TITLE",
        id: PAYMENTS.PACYPAL,
        maxWidth: "37%",
    },
    PACYPAL_BR: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2024/0709/49c905f601548eb62ca2f2f7855538dd.jpg",
        tips: "CREDIT_CARD_EXPLAIN",
        title: "CREDIT_CARD_TITLE",
        id: PAYMENTS.PACYPAL,
        maxWidth: "50%",
    },
    PACYPAL_CL: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2024/0708/89e2ce1cea430b424583796b61db0bc4.jpg",
        tips: "CREDIT_CARD_EXPLAIN",
        title: "CREDIT_CARD_TITLE",
        id: PAYMENTS.PACYPAL,
        maxWidth: "37%",
    },
    ONERWAY: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2021/0909/230a09b6812c899887c12bf78ca7d080.jpg",
        tips: "CREDIT_CARD_EXPLAIN",
        title: "CREDIT_CARD_TITLE",
        id: PAYMENTS.ONERWAY,
        maxWidth: "37%",
    },
    PACYPAL_SOFORT: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2021/0909/230a09b6812c899887c12bf78ca7d080.jpg",
        tips: "CREDIT_CARD_EXPLAIN",
        title: "CREDIT_CARD_TITLE",
        id: PAYMENTS.PACYPAL,
        maxWidth: "37%",
    },
    PACYPAL_GIROGATE: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2021/0909/230a09b6812c899887c12bf78ca7d080.jpg",
        tips: "CREDIT_CARD_EXPLAIN",
        title: "CREDIT_CARD_TITLE",
        id: PAYMENTS.PACYPAL,
        maxWidth: "37%",
    },
    USEEPAY: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2021/0909/230a09b6812c899887c12bf78ca7d080.jpg",
        tips: "CREDIT_CARD_EXPLAIN",
        title: "CREDIT_CARD_TITLE",
        id: PAYMENTS.USEEPAY,
        maxWidth: "37%",
    },
    KLARNA: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2022/0726/40c2d268c334c5cfb4f9da4776659842.png",
        tips: "Klarna",
        title: "Klarna",
        id: PAYMENTS.KLARNA,
        maxWidth: "13%",
    },
    OXXO: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2023/0703/7600cce51651a9fa33c3cf2b76728ed3.png",
        tips: "",
        title: "OXXO",
        id: PAYMENTS.OXXO,
        maxWidth: "25%",
    },
    MERCADOPAGO: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2023/0703/563f527579dc5fce8ca6a80f333133e7.png",
        tips: "",
        title: "MercadoPago",
        id: PAYMENTS.MERCADOPAGO,
        maxWidth: "75px",
    },
    SPEI: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2023/0703/7e55ae1db8a2f55be885c45adbed8679.png",
        tips: "",
        title: "SPEI",
        id: PAYMENTS.SPEI,
        maxWidth: "75px",
    },
    APPLEPAY: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2024/0126/842e4b61b535b556a8d185812ead6b1e.png",
        tips: "",
        title: "APPLEPAY_TITLE",
        id: PAYMENTS.APPLEPAY,
        maxWidth: "20%",
    },
    GOOGLEPAY: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2024/0126/dfb239c2f5e5f898cb7683cfcdf5d366.png",
        tips: "",
        title: "GOOGLEPAY_TITLE",
        id: PAYMENTS.GOOGLEPAY,
        maxWidth: "20%",
    },
    WEBPAY: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2024/0523/d3c040604db5d94b355d8d594fc3b68a.png",
        tips: "Webpay",
        title: "Webpay",
        id: PAYMENTS.WEBPAY,
        maxWidth: "18%",
    },
    SERVIPAG: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2024/0523/149cdc2fafda88472cdb71a53fbd772a.png",
        tips: "Servipag",
        title: "Servipag",
        id: PAYMENTS.SERVIPAG,
        maxWidth: "18%",
    },
    PIX: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2024/0523/e85b804c248b4ada58ddd9460a530d0b.png",
        tips: "Pix",
        title: "Pix",
        id: PAYMENTS.PIX,
        maxWidth: "12%",
    },
    BOLETO: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2024/0522/ff9ff922f6ec9d2aaaa32b6305bb16b0.svg",
        tips: "Boleto",
        title: "Cash(Boleto)",
        id: PAYMENTS.BOLETO,
        maxWidth: "20%",
    },
    BLIK: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2024/0703/66157cee3a3fb216e1ef55d8ec531de4.png",
        tips: "Blik",
        title: "Blik",
        id: PAYMENTS.BLIK,
        maxWidth: "18%",
    },
    PAYU: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2024/0703/e6eeb7a69e50a8f96b0fbf22928bc90f.png",
        tips: "PayU",
        title: "PayU",
        id: PAYMENTS.PAYU,
        maxWidth: "18%",
    },
    IDEAL: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2024/1106/26a9a49cd54a270c61db79d82b00615d.png",
        tips: "iDEAL",
        title: "iDEAL",
        id: PAYMENTS.IDEAL,
        maxWidth: "18%",
    },
    PRZELEWY24: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2024/0703/4754343d5f2483158ca41ef02f0e1906.png",
        tips: "Przelewy24",
        title: "Przelewy24",
        id: PAYMENTS.PRZELEWY24,
        maxWidth: "18%",
    },
    ADYEN: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2021/0909/230a09b6812c899887c12bf78ca7d080.jpg",
        tips: "CREDIT_CARD_EXPLAIN",
        title: "CREDIT_CARD_TITLE",
        id: PAYMENTS.ADYEN,
        maxWidth: "37%",
    },
    AIRWALLEX: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2021/0909/230a09b6812c899887c12bf78ca7d080.jpg",
        tips: "CREDIT_CARD_EXPLAIN",
        title: "CREDIT_CARD_TITLE",
        id: PAYMENTS.AIRWALLEX,
        maxWidth: "20%",
    },
    KUESKI_D: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2025/0526/fdfdfefc17a7a4c6557e499a971807e7.jpg",
        tips: "kueski",
        title: "kueski",
        id: PAYMENTS.SERVIPAG_D,
        maxWidth: "18%",
    },
    DLOCAL: {
        image: "https://df5apg8r0m634.cloudfront.net/images/2021/0909/230a09b6812c899887c12bf78ca7d080.jpg",
        tips: "CREDIT_CARD_EXPLAIN",
        title: "CREDIT_CARD_TITLE",
        id: PAYMENTS.DLOCAL,
        maxWidth: "20%",
    },
};

export const productTypes = {
    glass: "glass",
    addOn: "add-on",
    virtual: "virtual",
};
//记录localStorage 缓存key
export const WINDOW_LOCAL_KEYS = {
    IS_VISITED_REFERRAL_PAGE: "is_visited_referral_program_page", //老用户是否访问过 index.php?main_page=account_referralProgram 页面
    IS_CLICK_SHARE_REFERRAL_PAGE: "IS_CLICK_SHARE_REFERRAL_PAGE", //老带新页面，用户是否点击过分享按钮
};
//记录sessionStorage 缓存key
export const WINDOW_SESSION_KEYS = {
    BASKET_NUM_SESSION: "BASKET_NUM_SESSION",
    VAT_ALERT_IS_SHOW: "VAT_ALERT_IS_SHOW",
};

//染色镜商品专题列表
// export const dyeingControlPackageArr = getSiteConfiguration(
//   'dyeingControlPackageArr'
// );

//记录钱海支付 错误信息
export const OCEAN_PAY_ERROR_KEYS = "OCEAN_PAY_ERROR_KEYS";
export const OCEAN_PAY_NUMBER = "OCEAN_PAY_NUMBER";
//最小库存限制
export const OUT_OF_STORE_LIMIT = 0;

//评论列表一次加载条数
export const reviewPerPage = 5;

//试戴页面产品尺寸详情图片
export const tryOnSizeDec = {
    LensWidth:
        "https://df5apg8r0m634.cloudfront.net/images/74cd6248d78b0d7355f9eeaf5bce9370.png",
    BridgeWidth:
        "https://df5apg8r0m634.cloudfront.net/images/efc4c34f105d66ee9c1edbb1856ba807.png",
    TempleLength:
        "https://df5apg8r0m634.cloudfront.net/images/baa0f2c227270900bad6b731bec9ae6c.png",
    TotalWidth:
        "https://df5apg8r0m634.cloudfront.net/images/61e4109977fb60533bd22cd05c4bc2fc.png",
    LensDiagonalSize:
        "https://df5apg8r0m634.cloudfront.net/images/e224d4fc49fa0f4d200c9a519bd3dcc0.png",
    Weight: "https://df5apg8r0m634.cloudfront.net/images/5290aecc6bc67a41704cb11121035b7a.png",
    Material:
        "https://df5apg8r0m634.cloudfront.net/images/ec42964d0060bd35e3d4b40bf1fb9b51.png",
};

export const ES_SEARCH_TYPE = {
    ALL: 0,
    PRODUCTS: 1,
    HELP: 3,
    ARTICLES: 2,
    ORDERS: 4,
};
// 周年庆活动2 领取免费镜盒时间
export const MIRROR_BOX_FREE = "MIRROR_BOX_FREE";

// 周年庆活动2 免费镜盒的配件id
export const MIRROR_BOX_FREE_ADDON = "MIRROR_BOX_FREE_ADDON";

// 这个标记用来控制是否在倒计时结束后移除镜盒。
export const ADD_ON_THIS_DEVICE = "ADD_ON_THIS_DEVICE";

export const TIME_START_NOTICED = "TIME_START_NOTICED";
// 在倒计时结束的时候给出用户提示
export const TIME_END_NOTICED = "TIME_END_NOTICED";

// 2D试戴是否第一次使用标记
export const USED_IMAGE_TRY_ON = "USED_IMAGE_TRY_ON";
// 没有登录用户上传的图片缓存
export const IMG_TRY_ON_NOT_LOGIN_INFO_CACHE =
    "IMG_TRY_ON_NOT_LOGIN_INFO_CACHE";

// 记录Fit参数信息
export const MYFIT = "MYFIT";

// 2D试戴用户PD缓存
export const USR_PD = "USR_PD";

const freeChainNotEnd = Date.now() < 1669363200000; // 2022/11/25 16:00:00
const freeConstellationMirrorClothNotEnd = false; // 2022/12/05 16:00:00
export const freeChristmasGift = Date.now() > 1670227200000; // 2022/12/05 16:00:00

const freeGift = true;
/**
 * 星座专题页id
 * 顺序 1.白羊座 2.金牛座 3.双子座 4.巨蟹座 5.狮子座 6.处女座
 *     7.天秤座 8.天蝎座 9.射手座 10.摩羯座 11.水瓶座 12.双鱼座
 */
export const zodiacPageIds = (() => {
    const arr = [];
    if (freeConstellationMirrorClothNotEnd) {
        arr.push(
            12467,
            12468,
            12469,
            12470,
            12471,
            12472,
            12473,
            12474,
            12462,
            12475,
            12476,
            12477,
        );
    }
    if (freeChainNotEnd) {
        arr.push(14001);
    }
    if (freeChristmasGift) {
        arr.push(4010);
    }
    if (freeGift) {
        arr.push(14038, 14039, 14047);
    }
    return arr;
})();
export const zodiacPages = (() => {
    const arr = [];
    if (freeConstellationMirrorClothNotEnd) {
        arr.push(
            "ARIES",
            "TAURUS",
            "GEMINI",
            "CANCER",
            "LEO",
            "VIRGO",
            "LIBRA",
            "SCORPIO",
            "SAGITTARIUS",
            "CAPRICORN",
            "AQUARIUS",
            "PISCES",
        );
    }
    if (freeChainNotEnd) {
        arr.push(arr.push("CHAINS"));
    }
    if (freeChristmasGift) {
        arr.push("FreeChristmasGift");
    }
    return arr;
})();
/**
 * @type {[key:string]:number}
 */
export const zodiacPageIdMap = zodiacPages.reduce(
    (pre: Record<string | number, any>, page, idx) => {
        pre[page] = zodiacPageIds[idx];
        return pre;
    },
    {},
);

/** 星座专题页镜布id */
export const mirrorClothIds = (() => {
    const arr = [];
    if (freeConstellationMirrorClothNotEnd) {
        arr.push(525, 533, 532, 531, 530, 529, 528, 527, 526, 524, 523, 522);
    }
    if (freeChainNotEnd) {
        arr.push(920);
    }
    if (freeChristmasGift) {
        arr.push(931);
    }
    if (freeGift) {
        arr.push(1012, 1021, 1030);
    }
    return arr;
})();

// 继续执行站内转化的弹窗
export const UPALERT_RESUME = "UPALERT_RESUME";

// 记录用户操作选择站点modal的时间
export const OPERATE_TIME = "OPERATE_TIME";

// 检测honey插件
export const CHECK_HONEY = "CHECK_HONEY";

// 获取订单信息
export const GET_ORDER_DETAIL = "GET_ORDER_DETAIL";

//上一次打开网站的时间
export const LAST_TIME_THE_WEBSITE_WAS_OPENED =
    "LAST_TIME_THE_WEBSITE_WAS_OPENED";

export const UK_DRAW_START_TIME = 1669161600;
//new Date('2022-11-23 08:00:00').getTime()/1000
export const UK_DRAW_END_TIME = 1669247999;
//new Date('2022-11-24 07:59:59').getTime()/1000
export const UK_END_TIME = 1669507199;
//new Date('2022-11-27 07:59:59').getTime()/1000

export const US_DRAW_START_TIME = 1669190400;
//new Date('2022-11-23 16:00:00').getTime()/1000
export const US_DRAW_END_TIME = 1669276799;
//new Date('2022-11-24 15:59:59').getTime()/1000
export const US_DRAW_AD_TIME = 1669363200;
//new Date('2022-11-25 16:00:00').getTime()/1000
export const US_END_TIME = 1669535999;
//new Date('2022-11-27 15:59:59').getTime()/1000

export const pageType = {
    all: 0,
    index: 1,
    dynamic_page: 2,
    product: 3,
    lens: 4,
    newlens: 4,
    cart: 5,
    checkout: 6,
    user: 7,
    help_center: 8,
};

export const defaultImg =
    "https://df5apg8r0m634.cloudfront.net/images/2024/0710/52fd185aa6af2160e3d393614712400c.jpg";
